import RootStore from "../rootStore";
import saveHandler from "./saveHandler";

const saveAndNextImageHandler = (
  store: RootStore,
  appFetch: any,
  history: any,
  userLogin?: string | null
): boolean => {
  const { canSave, setResizeMode } = store.labelerSegmentationUiStore;
  const { isLoadingSave, isReadOnly } = store.labelerSegmentationStore;

  if (isReadOnly || isLoadingSave || !canSave()) return false;

  store.stickTwoPolygonsStore.resetPolyStick();
  setResizeMode(false);
  saveHandler(store, appFetch, history, userLogin);
  return true;
};

export default saveAndNextImageHandler;
